import {
  BrandVariants,
  createLightTheme,
  createDarkTheme,
  Theme,
} from "@fluentui/react-components";

// Brand ramp built around #235592
const brandVariants: BrandVariants = {
  10: "#020d17",
  20: "#0b1f33",
  30: "#0f2d4a",
  40: "#123a5e",
  50: "#164872",
  60: "#1a5687",
  70: "#1e5f92",
  80: "#235592", // base — themePrimary
  90: "#3a6a9e",
  100: "#507faa",
  110: "#6794b7",
  120: "#7fa9c3",
  130: "#98becf",
  140: "#b2d3dc",
  150: "#cde7ea",
  160: "#e8f4f6",
};

export const brandLightTheme: Theme = {
  ...createLightTheme(brandVariants),
};

export const brandDarkTheme: Theme = {
  ...createDarkTheme(brandVariants),
  // Dark theme overrides: ensure readable foreground on brand background
  colorBrandForeground1: brandVariants[110],
  colorBrandForeground2: brandVariants[120],
};
